const tempImageCache = new Map();

export function setCachedImageUrl (imageId, objectUrl) {
    tempImageCache.set(imageId, objectUrl);
}

export function getCachedImageUrl(imageId) {
  return tempImageCache.get(imageId);
}

export function clearCachedImageUrl(imageId) {
  tempImageCache.delete(imageId);
}

export function clearAllCachedImageUrls() {
  tempImageCache.clear();
}